import { isImage, isPdf } from "../../utils/index.jsx";
import style from "./FileDownloadLink.module.css";

export default function DocumentPreview({ name, mimetype, url }) {
  return (
    <>
      {isImage(mimetype) && (
        <img alt={name} src={url} className={style.previewImg} />
      )}
      {isPdf(mimetype) && (
        <object
          data={url}
          type="application/pdf"
          title={name}
          className={style.previewPdf}
        >
          <a href={url} target="_blank" rel="noreferrer">
            Cliquez ici pour télécharger le document
          </a>
        </object>
      )}
    </>
  );
}
